import { render, staticRenderFns } from "./VerifyAdminLogin.vue?vue&type=template&id=4a75a10b"
import script from "./VerifyAdminLogin.vue?vue&type=script&lang=ts"
export * from "./VerifyAdminLogin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports